module.exports = __webpack_public_path__ + "img/About_item_2.720afb93.png";